import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { StickyNote, Send } from "lucide-react";

export function ReportNotes({ notesUrl }) {
  const [notes, setNotes] = useState([]);
  const [draft, setDraft] = useState("");
  const [saving, setSaving] = useState(false);

  const fetchNotes = () => {
    api.get(notesUrl).then((res) => setNotes(res.data || [])).catch(() => setNotes([]));
  };

  useEffect(() => { fetchNotes(); }, [notesUrl]);

  const submit = async () => {
    if (!draft.trim()) return;
    setSaving(true);
    try {
      const res = await api.post(notesUrl, { note: draft.trim() });
      setNotes((prev) => [res.data, ...prev]);
      setDraft("");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="report-notes-panel">
      <h3 className="font-heading text-base font-semibold text-slate-900 mb-1 flex items-center gap-2">
        <StickyNote className="h-4.5 w-4 text-indigo-600" /> Counsellor Notes
      </h3>
      <p className="text-xs text-slate-400 mb-4">Private to staff only — never shown to the student.</p>

      <div className="flex gap-2 mb-5">
        <Textarea
          data-testid="report-note-input"
          placeholder="Add a private follow-up note about this student's report…"
          rows={2}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          className="text-sm"
        />
        <Button data-testid="report-note-submit-button" onClick={submit} disabled={saving || !draft.trim()} className="h-auto bg-indigo-600 hover:bg-indigo-700 shrink-0">
          <Send className="h-4 w-4" />
        </Button>
      </div>

      {notes.length === 0 && <p className="text-sm text-slate-400" data-testid="report-notes-empty">No notes yet.</p>}
      <div className="space-y-3">
        {notes.map((n) => (
          <div key={n.note_id} data-testid={`report-note-${n.note_id}`} className="rounded-xl bg-slate-50 border border-slate-100 p-3.5">
            <p className="text-sm text-slate-700 leading-relaxed whitespace-pre-wrap">{n.note}</p>
            <p className="text-xs text-slate-400 mt-2">
              {n.author_name} · {n.author_role === "SUPER_ADMIN" ? "Admin" : "Marketing Executive"} · {new Date(n.created_at).toLocaleString("en-IN")}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
